import React from "react";
import { Link } from 'react-router-dom';
import '../style/Payment.css';

export default function Payment() {
    return (
        <>
            <section className="section-9">
                <a className="a_h" href="/"> <i class="fa-solid fa-arrow-left me-3"></i>  Go to Home page</a>
                <div className="sec-9 mt-3">
                    <div className="box-9_l">
                        <div className="inputG">
                            <p>Card holder name</p>
                            <input type="text" name="" className="form-control"  id="" />
                        </div>
                        <div className="inputG">
                            <p>Card number</p>
                            <input type="number" name="" className="form-control"  id="" />
                        </div>
                        <div className="inputG_1">
                            <div className="inputgl">
                                <p>Expiry date</p>
                                <input type="text" className="form-control " />
                            </div>
                            <div className="inputgr">
                                <p>CVV code</p>
                                <input type="date" className="form-control"  />
                            </div>
                        </div>
                        <div className="box-t  d-flex">
                            <p className="lead tot mt-2" >Total payment (100%):</p>
                            <p  className="lead ms-3 mt-2">$50 000</p>
                        </div>
                        <div className="box-t d-flex">
                            <p className="lead">The amount you have to pay (30%):</p>
                            <p className="lead ms-2">$15 000</p>
                        </div>
                        <button className="btn btn-9">Sumbit</button>
                    </div>
                    <div className="box-9_r">
                    <img className="pimg" src={require("../img/14.png")} alt="Error" />

                    </div>
                </div>
            </section>
        </>
    )
}